import React from 'react';
import { Phone, Mail, MapPin, Twitter, Linkedin, Github } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0a0a0b] border-t border-gray-800">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <a href="/" className="flex items-center mb-4">
              <span className="text-xl font-bold text-white tracking-tight">
                AI<span className="text-teal-400">CONNEQTORS</span>
              </span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-500 hover:text-teal-400 transition-colors">
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-medium mb-4">{t('footer.product')}</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('footer.features')}</a></li>
              <li><a href="/pricing" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('nav.pricing')}</a></li>
              <li><a href="/integrations" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('nav.integrations')}</a></li>
              <li><a href="/releases" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('nav.releases')}</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-medium mb-4">{t('footer.resources')}</h4>
            <ul className="space-y-3">
              <li><a href="/docs" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('nav.docs')}</a></li>
              <li><a href="/docs" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('footer.apiReference')}</a></li>
              <li><a href="/releases" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('footer.blog')}</a></li>
              <li><a href="/contact-us" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('footer.helpCenter')}</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-medium mb-4">{t('footer.company')}</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('footer.about')}</a></li>
              <li><a href="/contact-us" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('footer.contact')}</a></li>
              <li><a href="/book-appointment" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('nav.bookDemo')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">{t('footer.privacy')}</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            {t('footer.copyright', { year: currentYear })}
          </p>
          <div className="flex gap-6">
            <a href="/terms" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              {t('footer.terms')}
            </a>
            <a href="/privacy" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              {t('footer.privacy')}
            </a>
            <a href="/cookies" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              {t('footer.cookies')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
